import instance from '../axios';

export const getAll = async () => {
  const response = await instance.get(`account-categories`);
  return response.data;
};
